import React from 'react';
import ErrorBoundary from '.';
export function withErrorBoundary(Component, debugComponent) {
    const decorated = (props)=>/*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: debugComponent
        }, /*#__PURE__*/ React.createElement(Component, props));
    decorated.displayName = `withErrorBoundary(${Component.displayName || 'Component'})`;
    return decorated;
}
